module.exports = __webpack_public_path__ + "img/icon-close-black-v2.6cdfc57e.svg";